/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** vertx (ignored)
 ** module id = 453
 ** module chunks = 0
 **/